import InteractivePanel from "@/components/interactive_panel";
import { Award } from "@/components/UI";
import UnpackgameInstanceItem from "@/components/UnpackgameInstanceItem";
import caseItem from "@/components/caseItem/index.vue";
import { conversion, countDownS } from "@/tool";
import * as apis from "@/api";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      gameInstanceBoxList: [],
      notice_modal_show: false,
      unpackgameInstance_item_show: false,
      unpackgameInstanceDetail: {},
      active_cate_index: 0,
      currentGameInstanceBoxObj: {},
      muxiang_case_info: {},
    };
  },
  components: {
    "c-award": Award,
    "c-interactive-panel": InteractivePanel,
    "c-unpackgameInstance-item": UnpackgameInstanceItem,
    "c-case-item": caseItem,
  },
  filters: {
    conversion,
  },
  async created() {
    //获取副本箱列表
    await this.getGameInstanceBoxList();
    this.setSpinShow(false);
  },
  methods: {
    toCaseCate(index) {
      window.scrollTo({
        top: this.heightToTop(this.$refs["caseloc" + index][0]),
        behavior: "smooth",
      });
      this.active_cate_index = index;
    },
    ...mapMutations(["setSpinShow"]),
    //获取副本箱列表
    async getGameInstanceBoxList() {
      let _this = this;
      const boxList_response = await apis.boxList();
      if (boxList_response.data.code !== 0) {
        return;
      }
      let gameInstanceBoxList = boxList_response.data.data.list.filter(
        (res) => res.catagory == "副本箱列表"
      );
      let promiseRes = new Promise((resolve, reject) => {
        gameInstanceBoxList.forEach((boxItem, boxIndex) => {
          setTimeout(async () => {
            boxItem["case_details"] = boxItem;
            let childList = [];
            boxList_response.data.data.list.forEach(async (items) => {
              //是否有累计副本箱=母箱
              if (
                items.isEnableAccumulateCase &&
                items.accumulateExtraCaseId &&
                items.accumulateExtraCaseId == boxItem.caseId
              ) {
                items.accumulateCaseRate = parseInt(items.accumulateCaseRate);
                items.accumulateCaseRoundCount = parseInt(
                  items.accumulateCaseRoundCount
                );
                items.awardAccumulateExtraCases =
                items.awardAccumulateExtraCases.filter(
                    (res) => {
                      return res.extraCaseId == items.accumulateExtraCaseId;
                    }
                  );
                items.awardAverageExtraCases =
                  items.awardAverageExtraCases.filter((res) => {
                    return res.extraCaseId == items.accumulateExtraCaseId;
                  });
                items["case_child_details"] = items;
                childList.push(items);
              }
            });
            boxItem["childList"] = childList;
          }, 200);
        });
        setTimeout(() => {
          resolve();
        }, 2000);
      });
      promiseRes.then(() => {
        _this.gameInstanceBoxList = gameInstanceBoxList;
        console.log(
          "查看 _this.gameInstanceBoxList===",
          _this.gameInstanceBoxList
        );
      });
    },
    pathGo(obj) {
      if (obj.name === "case") {
        return this.$router.push({
          name: "case",
          params: { id: obj.id },
          query: this.$route.query || {},
        });
      }
      this.$router.push({ ...obj, query: { ...(this.$route.query || {}), ...(obj.query || {}) } });
    },
    handleScroll() {
      var scrollTop = Math.floor(
        document.body.scrollTop || document.documentElement.scrollTop
      );
      this.gameInstanceBoxList.forEach(
        (cases_category, cases_category_index) => {
          var cat_dom = this.$refs["caseloc" + cases_category_index][0];
          var cate_dom_top = this.heightToTop(cat_dom);
          var cate_dom_top_overflow =
            cate_dom_top + Number(cat_dom.offsetHeight / 2);
          if (scrollTop >= cate_dom_top) {
            this.active_cate_index = cases_category_index;
          }

          if (scrollTop >= cate_dom_top_overflow) {
            this.active_cate_index = cases_category_index + 1;
          }
        }
      );
    },
    heightToTop(ele) {
      //ele为指定跳转到该位置的DOM节点
      let root = document.body;
      let height = -180;

      do {
        height += ele.offsetTop;
        ele = ele.offsetParent;
      } while (ele !== root);
      return height;
    },
    onClickHandle(data, gameInstanceObj, case_info) {
      if (
        case_info.case_child_details.isEnableAccumulateCase &&
        case_info.case_child_details.awardAccumulateExtraCases &&
        case_info.case_child_details.awardAccumulateExtraCases.length > 0
      ) {
        this.currentGameInstanceBoxObj = {
          fubenCaseId: gameInstanceObj.caseId,
          muxiangCaseId: case_info.caseId,
        };
        this.ToUnpack(gameInstanceObj, case_info);
      } else {
        this.pathGo({ name: "case", params: case_info, id: case_info.caseId });
      }
    },
    ToUnpack(gameInstanceObj, case_info) {
      this.unpackgameInstance_item_show = true;
      this.unpackgameInstanceDetail = gameInstanceObj;
      this.muxiang_case_info = case_info;
    },
    async onSyncHandle(data) {
      if (!data) {
        // console.log("更新数据，不能重新渲染");
        this.gameInstanceBoxList.forEach((items) => {
          if (items.caseId == this.currentGameInstanceBoxObj.fubenCaseId) {
            items.childList.forEach(async (item) => {
              if (item.caseId == this.currentGameInstanceBoxObj.muxiangCaseId) {
                //只更新母箱详情数据就够了
                const case_child_info_response = await apis.api_CaseDetail(
                  item.caseId
                );
                if (case_child_info_response.data.code !== 0) {
                  return;
                }
                const case_child_info =
                  case_child_info_response.data.data.caseInfo;

                case_child_info.awardAccumulateExtraCases =
                  case_child_info.awardAccumulateExtraCases.filter((res) => {
                    return res.extraCaseId == item.accumulateExtraCaseId;
                  });
                case_child_info.awardAverageExtraCases =
                  case_child_info.awardAverageExtraCases.filter((res) => {
                    return res.extraCaseId == item.accumulateExtraCaseId;
                  });
                item.case_child_details = case_child_info;
              }
            });
          }
        });
      }
    },
  },
};
